import io from "socket.io-client";
const sockets = io('https://git.heroku.com/classroom--2.git', { autoConnect: true, forceNew: true });
// const sockets = io('localhost:5000', { autoConnect: true, forceNew: true });
export default sockets;
